 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"shop":"shop","social":"social","deviceManagement":"deviceManagement","event":"event","admin":"admin","aliBey":"aliBey","user":"user","dashboard":"dashboard","workouts":"workouts","einmalig":"einmalig","HomeNew.vue":"HomeNew.vue","habit~nutrition":"habit~nutrition","nutrition":"nutrition","habit":"habit","chat":"chat","gf":"gf","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"fa42c46c","chunk-0c4c0fa9":"e18e6fcb","chunk-233a1da5":"e8a804b3","chunk-2d0ac1cd":"5f1bffde","shop":"3383c93a","chunk-1ae5ab22":"1f399709","chunk-1e90651e":"9cf00be5","chunk-1fb712dd":"67eeffca","chunk-41aa1ba0":"6b9744b0","chunk-1a18a45a":"d933c0e3","chunk-6e83591c":"22ec3898","social":"49dc29a6","deviceManagement":"84428608","event":"9d0c2110","chunk-217be9fa":"4eed72a2","admin":"ac324bf7","aliBey":"e943fdac","chunk-c5a69156":"0fa6b3fd","chunk-4ffaccba":"342c103a","chunk-81d503c2":"7da1e9ed","chunk-e155fa78":"df34cf1b","chunk-1a79e6b2":"339c7fcd","chunk-7f15a6c2":"9ae19506","user":"7c26b899","chunk-fda3fe0e":"14cbf717","chunk-8dabaea2":"260a4bfa","dashboard":"6911bcca","workouts":"96cbfa0c","einmalig":"11812fb0","chunk-502b709f":"c89c9c7a","chunk-9d9a3692":"7b6c4896","chunk-b067410a":"3dc4a508","HomeNew.vue":"1a060ddd","chunk-ef2249dc":"92d13441","chunk-fd7ca6de":"14f3927f","chunk-1e5ab8b6":"82e9eb4c","chunk-5397765a":"cb163718","habit~nutrition":"f177cb18","nutrition":"4b4bc609","habit":"83096d28","chunk-2d0ae56b":"da7c86ae","chunk-2d0bff72":"0f0c2fbd","chunk-2d0c8467":"38d19932","chunk-2d0dda10":"fc094788","chunk-2d225092":"6e15e463","chunk-35761728":"f1a84337","chat":"210ed7f9","chunk-45c97c5e":"3dbde622","chunk-4f70ea14":"a5c96af8","chunk-56abcd6a":"a234bf87","chunk-613e6a72":"37809a01","chunk-645be14f":"92fffc4a","chunk-28353157":"25c06214","chunk-6f66eaa9":"2e27b580","chunk-b6599cc6":"a8eb4d6f","chunk-16d05c62":"d334cda4","chunk-ea046250":"652643ca","gf":"26b1f9f7","chunk-7e90d637":"01041a45","chunk-855a8646":"4ae591fe","chunk-9826f532":"113a268a","chunk-b5f88a94":"c5ee135a","friends":"9db8c201","payment":"09903989","redirection":"3acbed28","chunk-2d209639":"94c15c44","chunk-2d216214":"1cff4ebd","chunk-2d216257":"58872a85","chunk-59b2e543":"6cf6c8f0","chunk-2d0c13c4":"7813a997","chunk-343dfed4":"94713753"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04a70578":1,"chunk-0c4c0fa9":1,"chunk-233a1da5":1,"shop":1,"chunk-1ae5ab22":1,"chunk-1e90651e":1,"chunk-1fb712dd":1,"chunk-1a18a45a":1,"social":1,"deviceManagement":1,"event":1,"chunk-217be9fa":1,"admin":1,"aliBey":1,"chunk-c5a69156":1,"chunk-4ffaccba":1,"chunk-81d503c2":1,"chunk-e155fa78":1,"chunk-1a79e6b2":1,"chunk-7f15a6c2":1,"user":1,"chunk-fda3fe0e":1,"chunk-8dabaea2":1,"dashboard":1,"workouts":1,"einmalig":1,"chunk-502b709f":1,"chunk-9d9a3692":1,"chunk-b067410a":1,"HomeNew.vue":1,"chunk-ef2249dc":1,"chunk-fd7ca6de":1,"chunk-1e5ab8b6":1,"chunk-5397765a":1,"habit~nutrition":1,"nutrition":1,"habit":1,"chunk-35761728":1,"chat":1,"chunk-45c97c5e":1,"chunk-4f70ea14":1,"chunk-56abcd6a":1,"chunk-613e6a72":1,"chunk-645be14f":1,"chunk-28353157":1,"chunk-6f66eaa9":1,"chunk-b6599cc6":1,"chunk-16d05c62":1,"chunk-ea046250":1,"gf":1,"chunk-7e90d637":1,"chunk-855a8646":1,"chunk-9826f532":1,"chunk-b5f88a94":1,"friends":1,"chunk-343dfed4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"shop":"shop","social":"social","deviceManagement":"deviceManagement","event":"event","admin":"admin","aliBey":"aliBey","user":"user","dashboard":"dashboard","workouts":"workouts","einmalig":"einmalig","HomeNew.vue":"HomeNew.vue","habit~nutrition":"habit~nutrition","nutrition":"nutrition","habit":"habit","chat":"chat","gf":"gf","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"d888e6e3","chunk-0c4c0fa9":"1a7a72fb","chunk-233a1da5":"aa93e336","chunk-2d0ac1cd":"31d6cfe0","shop":"1674ba39","chunk-1ae5ab22":"920258b6","chunk-1e90651e":"f95702ee","chunk-1fb712dd":"66a1c861","chunk-41aa1ba0":"31d6cfe0","chunk-1a18a45a":"fb6b55c2","chunk-6e83591c":"31d6cfe0","social":"38002047","deviceManagement":"23584837","event":"d8b22b17","chunk-217be9fa":"fd8c3217","admin":"dcc3b5a7","aliBey":"1b1433eb","chunk-c5a69156":"927289a6","chunk-4ffaccba":"df716a94","chunk-81d503c2":"cec12236","chunk-e155fa78":"a498c039","chunk-1a79e6b2":"806fd6fe","chunk-7f15a6c2":"70f8d107","user":"a854b304","chunk-fda3fe0e":"dee56bdd","chunk-8dabaea2":"cbec1d95","dashboard":"5ed54b76","workouts":"6ad82ebe","einmalig":"d24288df","chunk-502b709f":"58bd2dfb","chunk-9d9a3692":"27247be2","chunk-b067410a":"b4b6f499","HomeNew.vue":"fd7fd5c3","chunk-ef2249dc":"38cdad1c","chunk-fd7ca6de":"42016920","chunk-1e5ab8b6":"62891d0b","chunk-5397765a":"7481dedb","habit~nutrition":"551557c5","nutrition":"7d5e1320","habit":"346ce143","chunk-2d0ae56b":"31d6cfe0","chunk-2d0bff72":"31d6cfe0","chunk-2d0c8467":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d225092":"31d6cfe0","chunk-35761728":"781391a8","chat":"1a154ef8","chunk-45c97c5e":"e9b57efc","chunk-4f70ea14":"e234d813","chunk-56abcd6a":"d3c22eb9","chunk-613e6a72":"3fa4f906","chunk-645be14f":"01a3b69b","chunk-28353157":"aa93e336","chunk-6f66eaa9":"840f11ef","chunk-b6599cc6":"b71a634a","chunk-16d05c62":"9d5e1cc3","chunk-ea046250":"18f5051e","gf":"cbb0e40f","chunk-7e90d637":"a377727c","chunk-855a8646":"df716a94","chunk-9826f532":"1e86cea9","chunk-b5f88a94":"f7545db6","friends":"52064fe5","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-2d209639":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-59b2e543":"31d6cfe0","chunk-2d0c13c4":"31d6cfe0","chunk-343dfed4":"c20fdfa9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
